import { useEffect, useMemo, useState } from "react";
import { Doughnut, Line } from "react-chartjs-2";
import PaginationControl from "./PaginationControl";
import TrendChart from "./TrendChart";
import RoleDistributionChart from "./RoleDistributionChart";
import LoginHistoryTable from "./LoginHistoryTable";

export default function StatisticsAccordion({
  isStatsLoading,
  isExpanded,
  setIsExpanded,
  timeRange,
  setTimeRange,
  trendChartData,
  roleChartData,
  chartPlugins,
  trendChartOptions,
  chartRef,
  isLoading,
  loginHistories,
  offset,
  totalPages,
  searchName,
  setSearchName,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  currentPage,
  setCurrentPage,
  currentPerPage,
  setCurrentPerPage,
  pageNumbers,
  handlePageChange,
  handleResetFilter,
  mapppingColorForBGBadgeRole,
  selectedRole,
  setSelectedRole,
}) {
  const Roles = [
    "admin",
    "super-user",
    "user",
    "tls",
    "mo",
    "sales",
    "operational",
    "cs-online",
  ];

  return (
    <div className="accordion-body bg-light">
      <div className="row g-4 mb-4">
        <div
          className={`col-12 ${
            isExpanded ? "col-lg-12" : "col-lg-8"
          } transition-all`}
        >
          <TrendChart
            isStatsLoading={isStatsLoading}
            isExpanded={isExpanded}
            setIsExpanded={setIsExpanded}
            timeRange={timeRange}
            setTimeRange={setTimeRange}
            trendChartData={trendChartData}
            chartPlugins={chartPlugins}
            trendChartOptions={trendChartOptions}
            chartRef={chartRef}
          />
        </div>

        <div className="col-12 col-lg-4">
          <RoleDistributionChart
            isStatsLoading={isStatsLoading}
            roleChartData={roleChartData}
          />
        </div>
      </div>

      <hr className="my-4 text-muted" />

      <div className="card border-0 shadow-sm">
        <div className="card-header bg-white border-0 pb-0 pt-3">
          <h5 className="m-0 fw-bold">Riwayat Login Detail</h5>
        </div>

        <div className="card-body">
          <div className="mb-3">
            <div className="border rounded p-3 bg-white">
              <div className="row g-3 align-items-end">
                <div className="col-12">
                  <span className="fw-semibold small text-muted">
                    Filter Nama &amp; Tanggal
                  </span>
                </div>

                <div className="col-md-4">
                  <label className="form-label small text-muted mb-1">
                    Cari Nama User
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Ketik nama..."
                    value={searchName}
                    onChange={(e) => {
                      setSearchName(e.target.value);
                      setCurrentPage(1);
                    }}
                  />
                </div>

                <div className="col-md-3">
                  <label className="form-label small text-muted mb-1">
                    Tanggal Mulai
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    value={startDate}
                    onChange={(e) => {
                      setStartDate(e.target.value);
                      setCurrentPage(1);
                    }}
                  />
                </div>

                <div className="col-md-3">
                  <label className="form-label small text-muted mb-1">
                    Tanggal Akhir
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    value={endDate}
                    onChange={(e) => {
                      setEndDate(e.target.value);
                      setCurrentPage(1);
                    }}
                  />
                </div>

                <div className="col-md-2">
                  <label className="form-label small text-muted mb-1">
                    Role
                  </label>
                  <select
                    className="form-select form-select-sm"
                    value={selectedRole}
                    onChange={(e) => {
                      setSelectedRole(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">Semua Role</option>
                    {Roles.map((role) => (
                      <option key={role} value={role}>
                        {role}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-2 d-flex justify-content-end">
                  <button
                    type="button"
                    className="btn btn-outline-secondary w-100"
                    onClick={() => {
                      setSearchName("");
                      setStartDate("");
                      setEndDate("");
                      setSelectedRole("");
                      setCurrentPage(1);
                      handleResetFilter();
                    }}
                  >
                    <i className="fa fa-undo me-1" />
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-between align-items-center mb-3">
            <span className="fw-semibold">Daftar Login</span>
            <div className="d-flex align-items-center gap-2">
              <span className="small text-muted">Data per halaman</span>
              <select
                className="form-select form-select-sm w-auto"
                value={currentPerPage}
                onChange={(e) => {
                  setCurrentPerPage(parseInt(e.target.value));
                  setCurrentPage(1);
                }}
              >
                <option value="10">10 Data</option>
                <option value="50">50 Data</option>
                <option value="100">100 Data</option>
              </select>
            </div>
          </div>

          <LoginHistoryTable
            isLoading={isLoading}
            loginHistories={loginHistories}
            currentPage={currentPage}
            currentPerPage={currentPerPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
            mapppingColorForBGBadgeRole={mapppingColorForBGBadgeRole}
          />
        </div>
      </div>
    </div>
  );
}
